import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInspections = function SvgInspections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 50 16 86.787V144l64-36.787V50Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.353 44.53.125-4.177c0-2.172 1.88-4.177 4.051-4.177h3.947c2.318 0 4.406 2.005 4.406 4.177v4.176",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m111.353 44.53-4.177-8.354c-1.461-2.192-3.633-4.176-6.264-4.176H80.029c-2.63 0-4.802 1.984-6.264 4.176L67.5 44.53H40.353c-6.265 0-8.353 2.84-8.353 7.184v43.394C32 99.47 34.088 103 40.583 103h78.893c6.495 0 8.583-3.529 8.583-7.893V51.713c0-4.365-2.088-7.184-8.583-7.184h-8.123Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.47 94.647c12.687 0 22.971-10.284 22.971-22.97 0-12.687-10.284-22.971-22.97-22.971-12.687 0-22.971 10.284-22.971 22.97 0 12.687 10.284 22.971 22.97 22.971Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.47 84.206c6.92 0 12.53-5.61 12.53-12.53 0-6.92-5.61-12.529-12.53-12.529-6.92 0-12.529 5.61-12.529 12.53 0 6.92 5.61 12.529 12.53 12.529ZM46.618 65.412a6.265 6.265 0 1 0 0-12.53 6.265 6.265 0 0 0 0 12.53Z",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};

var Memo = /*#__PURE__*/memo(SvgInspections);

export { Memo as default };
//# sourceMappingURL=inspections.svg.js.map
